import React from 'react';
import ContentFeedbackBox from '../../../shared/ContentFeedbackBox';

import facebookIcon from '../../../../theme/assets/icones/facebook.svg';
import instagramIcon from '../../../../theme/assets/icones/instagram.svg';
import xIcon from '../../../../theme/assets/icones/x.svg';
import youtubeIcon from '../../../../theme/assets/icones/youtube.svg';

import './ParticipateView.less';

const nacionalWhatsapp = [
  ['Rádio Nacional FM', '5561999891201', '(61) 99989-1201'],
  ['Rádio Nacional AM', '5561996741536', '(61) 99674-1536'],
  ['Rádio Nacional da Amazônia', '5561996741568', '(61) 99674-1568'],
  ['Rádio Nacional do Rio de Janeiro', '5521971199966', '(21) 97119-9966'],
];

const mecSocials = [
  ['Facebook', 'https://www.facebook.com/radiomec/', facebookIcon],
  ['Instagram', 'https://www.instagram.com/radiomec/', instagramIcon],
  ['X', 'https://x.com/radiomec', xIcon],
];

const nacionalSocials = [
  ['Facebook', 'https://www.facebook.com/RadioNacionalBR', facebookIcon],
  ['Instagram', 'https://www.instagram.com/radionacionalbr/', instagramIcon],
  ['X', 'https://x.com/radionacionalbr', xIcon],
  ['YouTube', 'https://www.youtube.com/radionacionalbr', youtubeIcon],
];

function ContactLink({ href, children }: any) {
  return (
    <a
      className="participate-view__contactLink"
      href={href}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
}

export default function ParticipateView() {
  return (
    <main className="participate-view">
      <section className="participate-view__hero">
        <p className="participate-view__eyebrow">Fale com a gente</p>
        <h1>Participe dos programas</h1>
        <p>
          Você pode participar da nossa programação pedindo uma música, mandando
          um recado ou enviando uma ideia de programa.
        </p>
      </section>

      <section className="participate-view__grid">
        <article className="participate-view__card">
          <h2>Rádio Nacional</h2>

          <div className="participate-view__group">
            <h3>E-mail</h3>
            <ContactLink href="mailto:centraldoouvinte@ebc.com.br">
              centraldoouvinte@ebc.com.br
            </ContactLink>
          </div>

          <div className="participate-view__group">
            <h3>WhatsApp</h3>
            {nacionalWhatsapp.map(([label, phone, display]) => (
              <ContactLink key={phone} href={`https://wa.me/${phone}`}>
                <strong>{label}</strong>
                <span>{display}</span>
              </ContactLink>
            ))}
          </div>

          <div className="participate-view__socials">
            {nacionalSocials.map(([label, href, icon]) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
              >
                <img src={icon} alt="" />
              </a>
            ))}
          </div>

          <address>
            SCS – Quadra 08 – Bloco B 50/60 – 1º Subsolo
            <br />
            Brasília – DF, CEP: 70.333-900
          </address>
        </article>

        <article className="participate-view__card participate-view__card--mec">
          <h2>Rádio MEC</h2>

          <div className="participate-view__group">
            <h3>Central do Ouvinte</h3>
            <ContactLink href="https://wa.me/5521997100537">
              (21) 99710-0537
            </ContactLink>
          </div>

          <div className="participate-view__group">
            <h3>E-mail</h3>
            <ContactLink href="mailto:ouvinte@ebc.com.br">
              ouvinte@ebc.com.br
            </ContactLink>
          </div>

          <div className="participate-view__socials">
            {mecSocials.map(([label, href, icon]) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
              >
                <img src={icon} alt="" />
              </a>
            ))}
          </div>

          <address>
            Av. Gomes Freire, 474 – Centro
            <br />
            Rio de Janeiro – RJ, CEP: 20231-014
          </address>
        </article>
      </section>

      <ContentFeedbackBox />
    </main>
  );
}
